import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";

export class PushHintContainer extends Container {
    public constructor(commonResources: CommonResourcesPackage) {
        super();
        const clickText = new Text('CLICK', new ClickTextStyle());
        clickText.anchor.set(0.5);
        clickText.skew.set(0, -0.09);
        this.addChild(clickText);

        const allowText = new Text('ALLOW', new AllowTextStyle());
        allowText.anchor.set(0.5);
        allowText.skew.set(0, -0.09);
        allowText.position.set(90, 102);
        this.addChild(allowText);

        const hintArrow = new Sprite(commonResources.assets_common_ui_hint_arrow_right_png);
        hintArrow.anchor.set(0.5);
        hintArrow.angle = -50;
        hintArrow.position.set(294, -7);
        this.addChild(hintArrow);
    }
}

class ClickTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 78
        }));
    }
}

class AllowTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: [
                "#28a6ff",
                "#41dff7"
            ],
            fillGradientType: 1,
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 170
        }));
    }
}